import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {PriebezneHodnotenieComponent} from './priebezne-hodnotenie/priebezne-hodnotenie.component';
import {UpozorneniaComponent} from './upozornenia/upozornenia.component';
import {SkuskyComponent} from './skusky/skusky.component';
import {ZnamkyComponent} from './znamky/znamky.component';
import {PrehladyComponent} from './prehlady/prehlady.component';
import {AuthErrorComponent} from 'ais-common';

const routes: Routes = [
    { path: '', component: ZnamkyComponent, data: { title: 'Predmety' } },
    { path: 'predmety', component: ZnamkyComponent, data: { title: 'Predmety' } },
    { path: 'skusky', component: SkuskyComponent, data: { title: 'Skúšky' }  },
    { path: 'hodnotenia-priebezne', component: PriebezneHodnotenieComponent, data: { title: 'Priebežné hodnotenie' }  },
    { path: 'prehlady', component: PrehladyComponent, data: { title: 'Prehľady' }  },
    { path: 'harmonogram', component: UpozorneniaComponent, data: { title: 'Harmonogram akademického roka' }  },
    { path: 'auth-error', component: AuthErrorComponent },
    { path: '**', component: ZnamkyComponent, data: { title: 'Predmety' } },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
